import QuotationList from "./QuotationList.container";

export default QuotationList;
